import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';

function Home() {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background">
          <div className="animated-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
            <div className="shape shape-4"></div>
            <div className="shape shape-5"></div>
            <div className="shape shape-6"></div>
          </div>
          <div className="grid-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-icons">
              <div className="floating-icon icon-1">🤖</div>
              <div className="floating-icon icon-2">☁️</div>
              <div className="floating-icon icon-3">⚡</div>
              <div className="floating-icon icon-4">📊</div>
            </div>
            <h1>Transform Your Business with AI & Cloud Solutions</h1>
            <p className="hero-subtitle">
              Empowering SMEs across the US, UK, Middle East, and Australia with cutting-edge 
              AI-driven automation and cloud consulting services
            </p>
            <div className="hero-buttons">
              <Link to="/services" className="btn btn-primary">Explore Services</Link>
              <Link to="/contact" className="btn btn-secondary">Get Started</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="services-preview">
        <div className="container">
          <h2>Our Core Services</h2>
          <p className="section-subtitle">Comprehensive solutions to accelerate your digital transformation</p>
          
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">🤖</div>
              <h3>AI Workflow Automation</h3>
              <p>Automate HR, finance, and support processes with intelligent AI assistants and custom ChatGPT integrations</p>
              <Link to="/services/ai-workflow-automation" className="service-link">Learn More →</Link>
            </div>

            <div className="service-card">
              <div className="service-icon">☁️</div>
              <h3>Cloud & DevOps Setup</h3>
              <p>AWS/Azure infrastructure, CI/CD pipelines, and cost optimization for growing startups</p>
              <Link to="/services/cloud-devops" className="service-link">Learn More →</Link>
            </div>

            <div className="service-card">
              <div className="service-icon">📊</div>
              <h3>AI Strategy Consulting</h3>
              <p>Expert guidance on AI readiness, automation roadmaps, and ROI estimation</p>
              <Link to="/services/ai-strategy" className="service-link">Learn More →</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-us">
        <div className="container">
          <h2>Why Choose Us?</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <h3>SME Focused</h3>
              <p>Tailored solutions designed specifically for small and medium enterprises</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <h3>Proven Expertise</h3>
              <p>Deep experience in AI, cloud architecture, and process automation</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <h3>Cost Effective</h3>
              <p>Maximize ROI with optimized cloud spending and efficient automation</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <h3>Global Support</h3>
              <p>Serving businesses across US, UK, Middle East, and Australia</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <h3>Rapid Deployment</h3>
              <p>Quick implementation to get your automation running fast</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <h3>Ongoing Support</h3>
              <p>Continuous monitoring, maintenance, and optimization services</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Automate Your Business?</h2>
          <p>Let's discuss how AI and cloud solutions can transform your operations</p>
          <Link to="/contact" className="btn btn-primary">Schedule a Consultation</Link>
        </div>
      </section>
    </div>
  );
}

export default Home;
